import React, { useState, useContext, useRef, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import styles from './company-details.module.scss'
import Button from 'src/components//button/Button'
import Input from 'src/components//input/Input'
import { StateContext } from '../../AppContext'
import { baseApiURL } from 'src/utils/utils'
import { IState, IAddress, ParamTypes } from 'src/Interface'
import AutocompletePoi from 'src/components//autocomplete/AutocompletePoi'
import axios from 'axios'
import { toast } from 'react-toastify'
import { validEmail, validString } from 'src/utils/utils'
import Aside from 'src/components/aside/Aside'
import { DispatchContext } from 'src/AppContext'

interface IValues {
  name: string,
  contactPerson: string
  email: string
  address: IAddress
}

interface IErrors {
  name: boolean
  contactPerson: boolean
  email: boolean
}

interface IProps {
  close?: any
  companyId: string
}

const CompanyDetails: React.FunctionComponent<IProps> = ({ close, companyId }: IProps) => {
  const [loading, setLoading] = useState(false)
  const dispatch = useContext(DispatchContext)
  const [errors, setErrors] = useState<IErrors>({
    name: false,
    contactPerson: false,
    email: false,
  })
  const [values, setValues] = useState<IValues>({
    name: null,
    contactPerson: null,
    email: null,
    address: null
  })

  const imageRef = useRef(null)
  const [file, setFile] = useState<any>(null)
  const history = useHistory()
  const state: IState = useContext(StateContext)

  useEffect(() => {
    setValues({ ...state.company })
  }, [state.company])

  const toBase64 = (file: File) => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })

  const filese = async (file: File) => {

    const base64: any = await toBase64(file)
    imageRef.current.src = base64
    setFile(base64.replace(`data:${file.type};base64,`, ''))
  }

  const handleValidation = (regexp: RegExp, fieldName: string) => (value: string) => {
    let error = false
    if (value && regexp && !regexp.test(value || '')) {
      error = true

    }
    setErrors({
      ...errors,
      [fieldName]: error
    })
  }

  const updateCompanyInfo = () => {
    setLoading(true)
    if (state.user.accessToken) {

      axios.put(`${baseApiURL()}/companies/${companyId}`,
        {
          name: values.name ? values.name : null,
          contactPerson: values.contactPerson ? values.contactPerson : null,
          email: values.email ? values.email : null,
          status: 'ACTIVE',
          address: values.address,
          image: file ? {
            imageData: file,
            contentType: 'string'
          } : null
        }, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      }).then(() => {
        return null
      }).then(() => {
        axios(`${baseApiURL()}/companies/${companyId}`, {
          headers: {
            Authorization:
              `Bearer ${state.user.accessToken}`
          }
        }).then((result: any) => {
          dispatch({ type: 'SET_COMPANY', company: result.data })
          close()
          setLoading(false)
        }).catch((error: any) => {
          if (error.response) {
            toast(error.response.data.message)
          } else {
            toast('Der gik desværre noget galt. Prøv igen om lidt')
          }
        })
      }).catch((err: any) => {
        toast(err.response.data.message)
        setLoading(false)

      })
    }
  }

  const handleInputChange = (fieldName: string) => (value: string) => {
    setValues({
      ...values,
      [fieldName]: value
    })
  }

  const toggleCompanyStatus = () => {
    axios.post(`${baseApiURL()}/companies/${state.company.id}/status`,
      {
        active: state.company.status === 'ACTIVE' ? false : true
      }, {
      headers: {
        Authorization:
          `Bearer ${state.user.accessToken}`
      }
    }).then(() => null)
    .then(() => {
      axios(`${baseApiURL()}/companies/${companyId}`, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      }).then((result: any) => {
        dispatch({ type: 'SET_COMPANY', company: result.data })
        close()
        setLoading(false)
      }).catch((error: any) => {
        if (error.response) {
          toast(error.response.data.message)
        } else {
          toast('Der gik desværre noget galt. Prøv igen om lidt')
        }
      })
    }).catch((err: any) => {
      toast(err.response.data.message)
    })
  }

  const resetError = (fieldName: string) => {
    setErrors({
      ...errors,
      [fieldName]: false
    })
  }

  if (!state.company.id) {
    history.push(`/companies/${companyId}`)
  }

  return (
    <div className='tw-relative tw-flex tw-flex-col tw-flex-auto'>
      <header className={styles.header}>
        <h4>Oplysninger</h4>
        <span className={styles.closeIcon} onClick={close}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </span>
      </header>
      <div className={styles.container}>
        <div className='tw-flex tw-mb-3'>
          <img className={styles.logo} style={{ background: (imageRef.current && !imageRef.current.src) && !state.company.avatarImageUrl ? state.company.hexColor : '' }} ref={imageRef} src={state.company.avatarImageUrl} alt="" />
          <input accept='.png,.jpg,.jpeg' className={styles.file} onChange={(e) => filese(e.target.files[0])} type="file" name="" id="" />
        </div>
        <Input
          modifiers='tw-mb-3'
          value={values.name}
          label='Firmanavn'
          type='text'
          error={errors.name}
          placeholder='Indtast firmanavn'
          handleInputChange={() => handleInputChange('name')}
          name='name'
          resetError={() => resetError('name')}
          handleValidation={() => handleValidation(validString, 'name')}
        />

        <AutocompletePoi
          completedAddress={values.address}
          modifiers='tw-mb-3'
          label='Kvikbestil adresse'
          setAddress={() => handleInputChange('address')}
          name='addresse'
          placeholder='Indtast firmaadresse'
        />

        <Input
          modifiers='tw-mt-3'
          value={values.contactPerson}
          label='Kontakt person'
          type='text'
          placeholder='Indtast kontaktperson'
          error={errors.contactPerson}
          resetError={() => resetError('contactPerson')}
          handleValidation={() => handleValidation(validString, 'contactPerson')}
          handleInputChange={() => handleInputChange('contactPerson')}
          name='contactPerson'
        />

        <Input
          modifiers='tw-mt-3'
          value={values.email}
          label='Kontakt email'
          type='text'
          placeholder='Indtast email til kontaktperson'
          error={errors.email}
          resetError={() => resetError('email')}
          handleValidation={() => handleValidation(validEmail, 'email')}
          handleInputChange={() => handleInputChange('email')}
          name='email'
        />

      </div>
      <footer className={styles.footer}>
        {state.company.id !== state.user.companyId &&
          <>
            {state.company.status === 'ACTIVE' ?
              <Button type='destructive' label='Arkiver' modifiers='tw-mr-5 tw-ml-auto' handleClick={toggleCompanyStatus} /> :
              <Button type='primary' label='Aktivér' modifiers='tw-mr-5 tw-ml-auto' handleClick={toggleCompanyStatus} />
            }
          </>
        }
        <Button modifiers={state.company.id === state.user.companyId ? 'tw-ml-auto' : ''} loading={loading} type='primary' label='Gem ændringer' handleClick={updateCompanyInfo} />
      </footer>
    </div>
  )
}

export default CompanyDetails
